import { LitElement } from 'lit';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin.js';
import { Theme } from '@common/types/enum.js';
import { DisplayMode, Generation } from '@api-consent/schema/Enums.js';
import { ReplaceElementsMixin } from '@src/components/mixins/ReplaceElementsMixin.js';
import { templates } from '@src/components/templates/index.js';
import { config } from '@src/config/index.js';
import { store } from '@src/store/index.js';

export class LitElementExtended extends ReplaceElementsMixin(TemplatingMixin(LitElement, Theme.OCCL, templates)) {
  static get version() {
    const { version } = config;
    return version;
  }

  static get build() {
    return {
      target: '__buildTarget__',
      date: '__buildDate__',
    };
  }

  getDisplayMode(): DisplayMode {
    const { consents: { generation } } = store.getState();
    if (generation! < Generation.UNLOCK) {
      // @ts-expect-error TODO ich verstehe das nicht was hier bei coding gedacht wurde
      return undefined;
    }

    // @ts-expect-error "undefined or DisplayMode"
    return this.displayMode as DisplayMode;
  }

  isDisplayModeText(displayMode: DisplayMode = this.getDisplayMode()) {
    return displayMode === DisplayMode.TEXT;
  }

  isDisplayModeHidden(displayMode: DisplayMode = this.getDisplayMode()) {
    return displayMode === DisplayMode.HIDDEN;
  }

  isDisplayModeList(displayMode: DisplayMode = this.getDisplayMode()) {
    return displayMode === DisplayMode.LIST;
  }
}
